import React from 'react'

import { TextFieldProps as DefaultTextFieldProps } from '@mui/material/TextField'

import { StyledTextField } from './index.styles'

const InputText = ({ variant = 'outlined', size = 'small', type = 'text', ...props }: DefaultTextFieldProps) => {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <StyledTextField variant={variant} size={size} {...props} />
}

export default InputText
